import React from "react";
import image_placeholder from "../../../images/image_placeholder.svg";
import {ROLE_IMAGES_MINI, ROLE_NAMES_BIG_CARD, ROLES_COUNT} from "../../../constants/Constants";
import "./User_TeamOverviewState.css";
import agent from "../../../agent";

export default class User_TeamOverviewState extends React.Component {
    findTeamMemberByRole(team, roleId) {
        let member = team.filter(el => el.role.indexOf(roleId) !== -1)[0];
        return `${member.firstname} ${member.lastname}`;
    }

    render() {
        let mainStyle = {
            "paddingTop": "100px",
            "paddingLeft": "100px",
            "display": "flex",
            "flexDirection": "column",
            "justifyContent": "space-between",
            "alignItems": "flex-start"
        };

        let goals = this.props.team.goals;
        let values = this.props.team.values;

        let team = this.props.team.users;
        let roleCards = [];

        for (let i = 0; i < ROLES_COUNT; i++) {
            roleCards.push(<div className={"user-team-overflow__team-card"} key={i}>
                <img alt={"icon"} src={ROLE_IMAGES_MINI[i + 1]} className='role-image'/>
                <div className="user-team-overflow__role-info">
                    <div className="user-heading-level-3">{this.findTeamMemberByRole(team, i + 1)}</div>
                    <div className='role-text'>{ROLE_NAMES_BIG_CARD[i + 1]}</div>
                </div>
            </div>);
        }

        let imageProp = this.props.team.image;
        let teamImage = imageProp ? agent.FILES_ROOT + imageProp : image_placeholder;

        return <div className={"user-team-overview"} style={mainStyle}>
            <div className='user-header-text'>Презентация команды</div>
            <div className='user-team-overview__header'>
                <img src={teamImage} alt={"logo"} width={100} height={100}/>
                <div className='user-team-overview__main-info'>
                    <div className="user-team-overview__team-name user-subheading-text">{this.props.team.name}</div>
                    <div className="user-team-overview__values-container user-heading-level-3">
                        {
                            values.teamValues ? values.teamValues.map((el, i) => <div key={i}
                                className="user-team-overview__team-value">{el}</div>) : ""
                        }
                    </div>
                </div>
            </div>

            <div className="user-team-overview__goals">
                <div className="user-subheading-text">Цели</div>
                <div className="user-team-overview__goals-container">
                    {
                        goals.goals ? goals.goals.map((el, i) => <div key={i}
                            className="user-team-overview__team-goal">{el}</div>) : ""
                    }
                </div>
            </div>

            <div className="user-team-overview__team">
                <div className="user-subheading-text">Команда</div>
                <div className="user-team-overview__team-container">
                    {roleCards}
                </div>
            </div>
        </div>
    }

}
